/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import {
    array, string,  arrayOf, shape,
} from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';

import ReactMarkdown from 'react-markdown';
import PDPSliderAddon from './PDPSliderAddon';
import transformRenderer from '../../../../../../../helpers/markdown/characterTransformer';
import { trackEvent } from '../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { setSelectedInlineAddons } from '../../../../../../../../state/ducks/App/App-Actions';
import { getSelectedInlineAddons } from '../../../../../../../../state/ducks/App/App-Selectors';

const useStyle = makeStyles((theme) => ({
    titleSlider: {
        lineHeight: '25px',
        fontSize: '20px',
        display: 'flex',
        fontFamily: 'museo-sans, "Area Variable"',
        margin: '0px',
        padding: '0px',
        [theme?.breakpoints?.down(600)]: {
            lineHeight: '23px',
            fontSize: '18px',
        },
    },

    mainContainer: {
        width: '100%',
    },

}));

const PDPAddonUI = ({
    addOnHoverInfo,
    content,
}) => {
    const classes = useStyle();
    const addonInfo = addOnHoverInfo?.[0] || {};
    const heading =  addonInfo?.heading;
    const [selectedItems, setSelectedItems] = useState({});
    const [openModal, setOpenModal] = useState(false);
    const [modalItemList, setModalItemList] = useState([]);
    const [typeItem, setTypeItem] = useState('');
    const [groupItemId, setGroupItemId] = useState('');
    const [groupItemName, setGroupItemName] = useState('');
    const selectAddons = useSelector(getSelectedInlineAddons);
    const scrollPositionRef = React.useRef(0);
    const dispatch = useDispatch();

    const groupAddons = (addons) => {
        const grouped = addons.reduce((acc, item) => {
            const { parentKey, ...rest } = item;
            if (!acc[parentKey]) {
                acc[parentKey] = [];
            }
            acc[parentKey].push(rest);
            return acc;
        }, {});
        setSelectedItems(grouped); // set state instead of returning
    };

    useEffect(() => {
        if (selectAddons.length > 0) {
            groupAddons(selectAddons);
        }
    }, [selectAddons]);

    let selectedItemsModal = [];
    if (typeItem === 'addons' && selectedItems && selectedItems[groupItemId]) {
        selectedItemsModal = selectedItems[groupItemId];
    }

    const getSelectAddonsByGroup = (data) => {
        let selectedGroupId = '';
        const listSelectedItem = [];

        Object.keys(selectedItems).forEach((groupId) => {
            if (groupId === data.id) {
                selectedItems[groupId].forEach((item) => {
                    listSelectedItem.push(item.partNumber);
                });
            }
        });

        if (Object.keys(selectedItems).length > 0) { // state object for selected is not 0
            selectedGroupId = data.addons
                .map((item) => item)
                .filter((item) => listSelectedItem.includes(item.id));
            if (selectedGroupId.length > 0) {
                selectedGroupId = selectedGroupId[0]?.id;
            }
            if (selectedGroupId.length === 0) {
                selectedGroupId = '';
            }
        }
        return selectedGroupId;
    };

    const addonsWithParent = ((items) => Object.entries(items).flatMap(([parentKey, addons]) => addons.map((addon) => ({
        parentKey,
        quantity: 1,
        ...addon,
    })),
    ));

    const selectItems = (itemDetails, groupId, groupName) => {
        // Copy state to avoid mutation
        const newSelectedItems = { ...selectedItems };

        // Ensure group exists
        if (!newSelectedItems[groupId]) {
            newSelectedItems[groupId] = [];
        }

        // Find if item already exists
        let keyPosition = -1;
        selectedItems[groupId]?.forEach((item, keyItem) => {
            if (item?.id === itemDetails.id) {
                keyPosition = keyItem;
            }
        });

        if (keyPosition > -1) {
            // If only one item in group → remove group
            if (newSelectedItems[groupId]?.length === 1) {
                delete newSelectedItems[groupId];
            } else {
                // Remove only that item
                newSelectedItems[groupId].splice(keyPosition, 1);
            }
        } else {
            // Add item
            newSelectedItems[groupId].push({
                ...itemDetails,
                groupName,
            });
        }

        // Track event
        dispatch(trackEvent({
            eventCategory: 'Product Page',
            eventAction: 'Click',
            eventLabel: 'Product Addon Selected ',
            feature_detail: 'Addons',
            feature_element: 'Click',
            feature_category: 'Product Page',
        }));

        // Update state
        setSelectedItems(newSelectedItems);
        const addonData = addonsWithParent(newSelectedItems);
        dispatch(setSelectedInlineAddons(addonData));
    };
    const removeItems = (itemDetails, groupId, groupName) => {
        const newSelectedItems = { ...selectedItems };
        // Check if the entire group (parent ID array) exists
        if (newSelectedItems[groupId]) {
            // If the group exists, remove the entire group
            delete newSelectedItems[groupId];
        }

        // Track event
        dispatch(trackEvent({
            eventCategory: 'Product Page',
            eventAction: 'Click',
            eventLabel: 'Product Addon Removed ',
            feature_detail: 'Addons',
            feature_element: 'Click',
            feature_category: 'Product Page',
        }));
        const addonData = addonsWithParent(newSelectedItems);
        setSelectedItems(newSelectedItems);
        dispatch(setSelectedInlineAddons(addonData));
    };

    const handleOpenModal = (type, itemList, itemId, itemName) => {
        scrollPositionRef.current = window.scrollY;
        setOpenModal(true);
        setModalItemList(itemList);
        setTypeItem(type);
        setGroupItemId(itemId);
        setGroupItemName(itemName);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setModalItemList({});
        setTypeItem('');
        setGroupItemId('');
        setGroupItemName('');
        requestAnimationFrame(() => {
            window.scrollTo(0, scrollPositionRef.current);
        });
    };
    return (
        <div className={`${classes.mainContainer}`}>
            {content.length > 0
                ? (
                    <div className={classes.root}>
                        {heading && <div className={classes.titleSlider}><ReactMarkdown renderers={transformRenderer} source={heading} escapeHtml={false} /></div>}
                        <PDPSliderAddon
                            handleOpenModal={handleOpenModal}
                            selectedItems={selectedItems}
                            addOnHoverInfo={addOnHoverInfo}
                            content={content}
                            getSelectAddonsByGroup={getSelectAddonsByGroup}
                            selectItems={selectItems}
                            removeItems={removeItems}
                            wrapupAddonRedesign
                            openModal={openModal}
                            modalItemList={modalItemList}
                            typeItem={typeItem}
                            groupItemId={groupItemId}
                            groupItemName={groupItemName}
                            handleCloseModal={handleCloseModal}
                            selectedItemsModal={selectedItemsModal}
                        />
                    </div>
                ) : null}
        </div>
    );
};
PDPAddonUI.propTypes = {
    content: array.isRequired,
    addOnHoverInfo: arrayOf(shape({
        info_on_hover: string,
        product_sku_part_numbers: string,
        see_more_info: string,
    })).isRequired,
};

export default PDPAddonUI;
